import * as React from 'react';
import { DrawerWithBar, ButtonInline } from 'ui';
import { MainGridContainer } from 'ui/common/main-grid-container/main-grid-container';
import { DisplaySelectedOptions } from 'app/components/display-selected-options/display-selected-options';
import { PropagateResize } from 'app/components/resize-hooks';
import { SearchFiltersTranslation } from '../constants';
import { FilterConfigurationProps, PredefinedIds } from './types';
import { FilterItem } from './filter-item';
import { FilterPredefined } from './filter-predefined';
import { mapToSummary } from './map-to-summary';
import { countFilter } from './selectors';

import styles from './search-filters.scss';

interface FilterListProps {
  filterSettings: FilterConfigurationProps;
  translation: SearchFiltersTranslation;
  locale: string;
  hideDrawer: boolean;
  wideScreen: boolean;
}

export const SearchFilters: React.FC<FilterListProps> = props => {

  const { filterSettings, translation, locale, children, hideDrawer, wideScreen } = props;

  if (!filterSettings || (!filterSettings.filters && !filterSettings?.predefinedFilters?.values) ||
    (filterSettings?.filters.length === 0 && filterSettings?.predefinedFilters?.values.length === 0)) {
    return <MainGridContainer>
      {children}
    </MainGridContainer>;
  }

  const { filters, values, onChange, menuValues, predefinedFilters, openFilters,
    openCloseFilter, filterValidation } = filterSettings;
  const { [PredefinedIds.include]: include = [], [PredefinedIds.exclude]: exclude = [] } = values || {};

  const count = (include.length > 0 || exclude.length > 0 ? 1 : 0) +
    filterSettings.filters.reduce(
      (total, filter) => total + (countFilter(filter.fields, values, filter.id) > 0 ? 1 : 0), 0);

  const countText = count > 0 ? ' (' + count + ')' : '';

  const drawerContent = <PropagateResize>
    <div className={styles.informationPanel}>
      <ButtonInline onClick={filterSettings.clearAllFilters} id="search-filters-clear-all">
        {translation.clear_all_filters}
      </ButtonInline>
    </div>

    {!!predefinedFilters?.values?.length
      && <FilterPredefined
        includeValues={values && values[PredefinedIds.include]}
        excludeValues={values && values[PredefinedIds.exclude]}
        predefinedFilters={predefinedFilters}
        onChange={onChange}
        open={openFilters && openFilters[PredefinedIds.filter]}
        openCloseFilter={openCloseFilter}
        translation={translation}
        locale={locale}
      />}

    {filters.map(filter => <FilterItem
      key={filter.id}
      translation={translation}
      locale={locale}
      filter={filter}
      filterSettings={filterSettings}
    />)}
  </PropagateResize>;

  const summary = <DisplaySelectedOptions
    selectedOptions={mapToSummary({ filters, values, menuValues, translation, locale, filterValidation })}
    textHideDetails={translation.hide_details}
    textShowDetails={translation.show_details}
  />;

  return <div className={`container main-grid ${styles.searchResults}`}>
    {
      hideDrawer
        ? children
        : <DrawerWithBar
          title={`${translation.filters_title}${countText}`}
          barContent={summary}
          drawerContent={drawerContent}>
          <div className={`caselisting ${wideScreen ? 'wide-screen' : 'narrow-screen'}`}>
            {children}
          </div>
        </DrawerWithBar>
    }
  </div>;
};
